import { useSyncExternalStore } from "react";
import {
  isAddinsLinksToFactsetWorkstationEnabled,
  subscribeAddinsLinksToFactsetWorkstation,
} from "./addinsLinksToFactsetWorkstation";

/**
 * React-bound view over `isAddinsLinksToFactsetWorkstationEnabled`.
 * Re-renders when ConfigCat `enableAddinsLinksToFactsetWorkstation` is
 * published into the shared cache.
 */
export function useAddinsLinksToFactsetWorkstationEnabled(): boolean {
  return useSyncExternalStore(
    subscribeAddinsLinksToFactsetWorkstation,
    isAddinsLinksToFactsetWorkstationEnabled,
    () => false,
  );
}
